import {RootState} from '../store.main';

export const getAccessToken = (store: RootState) => store.userReducer.accessToken;

export const getRefreshToken = (store: RootState) => store.userReducer.refreshToken;
